<template>
  <appbar-view></appbar-view>
  <div class="main-content">
    <v-container>

      <!-- Boton de filtros -->

      <!-- Botón de filtros -->
      <v-row justify="end" class="mt-0 mb-2">
        <v-btn icon color="orange-darken-3" variant="flat" size="small" @click="toggleSearch">
          <v-icon>{{ showSearch ? "mdi-close" : "mdi-magnify" }}</v-icon>
        </v-btn>

        <v-text-field v-if="showSearch" ref="searchField" v-model="searchQuery" placeholder="Buscar productos"
          variant="outlined" color="orange-darken-3" hide-details density="comfortable" class="ml-2"
          style="max-width: 260px" />

        <v-col cols="auto">
          <v-tooltip text="Filtrar y ordenar">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" variant="outlined" color="grey-darken-1"
                class="rounded-lg px-4 py-2 text-indigo-darken-4 d-flex align-center" @click="dialogFiltro = true">
                <v-icon class="mr-2" color="grey-darken-1">mdi-filter-variant</v-icon>
                <span class="font-weight-medium text-caption text-uppercase text-grey-darken-2">
                  Filtrar
                </span>
              </v-btn>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- Filtro de precios menor que y mayor que -->
      <v-dialog v-model="dialogFiltro" max-width="420">
        <v-card class="rounded-lg" color="text-white">
          <v-card-title class="bg-blue-darken-4 text-white">
            <v-icon class="mr-2">mdi-filter-cog</v-icon> Filtrar y ordenar
          </v-card-title>

          <v-card-text class="py-4">
            <v-switch v-model="sortByPrice" color="blue-darken-4" label="Ordenar por precio">
              <template v-slot:label>
                <v-icon small class="mr-1"></v-icon>
                <div class="text-blue-darken-4"><strong> De menor a mayor</strong></div>
              </template>
            </v-switch>
            <v-btn color="#223b78" variant="flat" class="rounded-lg px-4 text-white" @click="applyFilters">
              <v-icon class="mr-1">mdi-check</v-icon>
              Aplicar
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Botón del carrito flotante -->
      <!-- Boton de ver canasta  -->
      <v-btn icon class="floating-cart-btn" color="blue-darken-4" @click="openCart" elevation="10">
        <v-icon color="white" size="28">mdi-cart-outline</v-icon>
        <span v-if="totalCajas > 0" class="cart-badge">{{ totalCajas }}</span>
      </v-btn>
      <!-- Productos -->
      <!-- Productos -->
      <v-row dense>
        <v-col v-for="product in filteredProducts" :key="product.id" cols="6" sm="6" md="4" lg="3"
          class="d-flex justify-center">
          <v-card class="pa-4" variant="flat" color="transparent" style="width: 240px">
            <v-row>
              <div class="d-flex align-center" style="position: relative">
                <!-- Bloque de botones dinámicos -->
                <div v-if="getProductQuantity(product) > 0" class="d-flex align-center mt-2">
                  <!-- Botón disminuir / eliminar -->
                  <v-btn icon @click="
                    getProductQuantity(product) === 1
                      ? removeFromCart(product)
                      : decreaseQuantity(product)
                    " variant="text" density="compact" :color="getProductQuantity(product) === 1 ? 'red' : 'orange-darken-1'
                        ">
                    <v-icon>
                      {{
                        getProductQuantity(product) === 1
                          ? "mdi-delete"
                          : "mdi-minus-circle"
                      }}
                    </v-icon>
                  </v-btn>

                  <!-- Cantidad actual -->
                  <span class="px-2 text-caption font-weight-bold" style="font-size: 1.2em">
                    {{ getProductQuantity(product) }}
                  </span>

                  <!-- Botón aumentar -->
                  <v-btn icon size="42" @click="increaseQuantity(product)" density="compact" variant="text"
                    color="blue-darken-4" :disabled="product.id_promocion
                        ? getProductQuantity(product) >= 5
                        : getProductQuantity(product) >= product.yfr_disponible
                      ">
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-row>

            <v-row class="d-flex justify-center" style="position: relative">
              <v-col cols="9" style="position: relative">
                <!-- Imagen -->
                <v-img lazyloading :src="product.foto || 'default-image-url'" height="100px" class="rounded"
                  size="40" />

                <!-- Icono de agregar -->
                <v-icon color="blue-darken-4" size="42" v-ripple class="add-icon" style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      background: white;
                      border-radius: 50%;
                      padding: 2px;
                      cursor: pointer;
                    " :disabled="product.id_promocion
                        ? getProductQuantity(product) >= 1 // 🔒 Si tiene promo, solo 1
                        : getProductQuantity(product) >= product.yfr_disponible
                      " @click="
                      ((product.id_promocion && getProductQuantity(product) < 1) ||
                        (!product.id_promocion &&
                          getProductQuantity(product) < product.yfr_disponible)) &&
                      addToCart(product)
                      " :class="{
                      'v-icon--disabled': product.id_promocion
                        ? getProductQuantity(product) >= 1
                        : getProductQuantity(product) >= product.yfr_disponible,
                    }" :style="getProductQuantity(product) > 0
                        ? 'pointer-events: none; opacity: 0;'
                        : ''
                      ">
                  mdi-plus-circle
                </v-icon>
              </v-col>
            </v-row>

            <!-- Precio / Promo -->
            <div class="w-full text-center mt-4 p-3 transition-shadow duration-300 space-y-1">
              <template v-if="product.id_promocion && product.promo_price">
                <div class="text-gray-500 line-through font-semibold">
                  ${{ product.price }}
                </div>
                <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                  ${{
                    (
                      product.price -
                      (product.price * product.promo_price) / 100
                    ).toFixed(2)
                  }}
                </div>
              </template>
              <template v-else>
                <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-700">
                  ${{ product.price }}
                </div>
              </template>

              <!-- Nombre -->
              <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                {{ product.nombre }}
              </div>

              <!-- SKU -->
              <div class="text-xs sm:text-sm font-medium text-gray-400">
                SKU: {{ product.sku }}
              </div>

              <!-- Distintivo de promoción -->
              <div v-if="product.id_promocion && product.promo_price"
                class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full">
                Descuento {{ product.promo_price }}%
              </div>

              <!-- Agotado -->
              <div v-if="product.yfr_disponible <= 0" class="text-sm sm:text-base font-semibold text-red-500">
                Agotado
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Diálogo del carrito -->
      <CartDialog v-model="cartDialog" />
    </v-container>
  </div>
  <bottom-navigation />
</template>


<script>
import AppbarView from ".././components/appbar/appbarView.vue";
import BottomNavigation from "./../components/submenu/BottomNavigation.vue";
import CartDialog from "./Administrador/CarritoViewStore.vue"; // Asegúrate de que la ruta sea correcta
import { inject, computed } from "vue";
import { ref, nextTick } from "vue";
import api from "@/services/api";
import { useUserStore } from "@/stores/userStore";


export default {
  name: "ToplView",
  components: { BottomNavigation, AppbarView, CartDialog },
  setup() {
    // Inyectar el store del carrito
    const userStore = useUserStore();
    const cartStore = inject("cartStore"); // Asegúrate de que 'cartStore' esté proporcionado globalmente
    const showSearch = ref(false);
    const searchQuery = ref("");
    const searchField = ref(null);

    // Usar los métodos del store global
    const addToCart = cartStore.addToCart;
    const increaseQuantity = cartStore.increaseQuantity;
    const decreaseQuantity = cartStore.decreaseQuantity;
    const removeFromCart = cartStore.removeFromCart;
    const getProductQuantity = cartStore.getProductQuantity;
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });
    // Alternar búsqueda
    const toggleSearch = async () => {
      if (showSearch.value) {
        // Si ya está abierto, vaciar búsqueda y ocultar campo
        searchQuery.value = "";
        showSearch.value = false;
      } else {
        // Si estaba cerrado, mostrar campo y enfocar
        showSearch.value = true;
        await nextTick();
        searchField.value?.focus();
      }
    };

    // Ocultar búsqueda si pierde foco y está vacío
    const hideSearch = () => {
      if (!searchQuery.value.trim()) {
        showSearch.value = false;
      }
    };
    return {
      userStore, // 🔑 MUY IMPORTANTE

      showSearch,
      searchQuery,
      searchField,
      removeFromCart,
      addToCart, // Usar el método global para agregar al carrito
      increaseQuantity, // Usar el método global para aumentar la cantidad
      decreaseQuantity, // Usar el método global para disminuir la cantidad
      getProductQuantity,
      totalCajas,
      hideSearch,
      toggleSearch,
    };
  },
  data() {
    return {
      products: [],
      cart: [],
      cartDialog: false,
      suggestedItems: [],
      sortByPrice: false,
      dialogFiltro: false,
      selectedBrands: [], // Para múltiples valores
      selectedBrand: null,
      currentPage: 1,
      hasMoreProducts: true,
      brands: [], // Aseguramos que las marcas estén vacías al inicio
    };
  },
  computed: {
    filteredProducts() {
      let products = this.products.filter((product) => {
        const matchesSearch = product.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesBrand = this.selectedBrand
          ? product.sublinea === this.selectedBrand
          : this.selectedBrands.length > 0
            ? this.selectedBrands.includes(product.sublinea)
            : true;

        return matchesSearch && matchesBrand;
      });
      if (this.sortByPrice) {
        products = products.sort((a, b) => a.price - b.price);
      }

      return products;
    },
  },
  methods: {
    clearCart() {
      this.cart = []; // Vaciar el carrito
      localStorage.removeItem("cart"); // Limpiar el almacenamiento local
    },

    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },

    applyFilters() {
      this.dialogFiltro = false;
    },

    async fetchProducts(page = 1) {
      try {
        if (!this.userStore.isAuthenticated) return;

        const token = this.userStore.token;
        if (!token) return;

        const limit = 250;
        const offset = (page - 1) * limit;

        const response = await api.get(
          "https://mvexpress.mx/api/promotions/promotional-products",
          {
            params: { limit, offset },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const fetchedProducts = response.data.map(p => ({
          ...p,
          price: p.price || 0,
        }));

        this.products.push(...fetchedProducts);
        this.hasMoreProducts = fetchedProducts.length >= limit;
        this.brands = [...new Set(this.products.map(p => p.sublinea))];

      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },


    loadMoreProducts() {
      if (this.hasMoreProducts) {
        this.currentPage++;
        this.fetchProducts(this.currentPage);
      }
    },

    suggestedProducts() {
      if (!this.userStore.isAuthenticated) return;

      const token = this.userStore.token;
      if (!token) return;

      api.get("https://mvexpress.mx/api/productos/suggested-products", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(res => {
          this.suggestedItems = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => console.error(err));
    },

    handleScroll() {
      const scrollPosition = window.innerHeight + window.scrollY; // Posición actual del scroll
      const bottomPosition = document.documentElement.offsetHeight; // Altura total del documento

      // Si el usuario está cerca del final de la página, cargar más productos
      if (scrollPosition >= bottomPosition - 100 && this.hasMoreProducts) {
        this.loadMoreProducts();
      }
    },
  },
  async mounted() {
    // ⏳ Esperar sesión
    if (!this.userStore.isSessionReady) {
      await this.userStore.initSession();
    }

    // 🔐 Validar sesión
    if (!this.userStore.isAuthenticated) {
      this.$router.replace("/login");
      return;
    }

    // 🚀 Cargar data
    this.fetchProducts();

    const saveCart = localStorage.getItem("cart");
    if (saveCart) {
      this.cart = JSON.parse(saveCart);
    }

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }


};
</script>


<style>
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}

.main-content {
  min-height: 100vh;
  padding-bottom: calc(env(safe-area-inset-bottom) + 220px) !important;
}

.floating-cart-btn {
  position: fixed;
  bottom: 150px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}

.fixed-cart-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  /* SUBE el botón justo arriba de la bottom nav */
  bottom: calc(env(safe-area-inset-bottom) + 70px);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
  background-color: #fff;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom);
  /* respeta la zona segura del teléfono */
  z-index: 9999;
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}
</style>